import hydrate from '../common/hydrate';
import CommonDisclaimer from './components/CommonDisclaimer';
import { root, name } from './manifest.json';
hydrate(CommonDisclaimer, root, name);
if (module.hot) {
    module.hot.accept();
}
